import { render } from "./PageSpeed.vue?vue&type=template&id=5d23cd9b"
import script from "./PageSpeed.vue?vue&type=script&lang=js"
export * from "./PageSpeed.vue?vue&type=script&lang=js"

import "./PageSpeed.vue?vue&type=style&index=0&id=5d23cd9b&lang=scss"

import exportComponent from "/Users/ntt/Documents/projects/foxartbox.com/www/fab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__